// Linus: hält die alte Print-Button-Funktion getrennt vom Theme-Core und bindet sie nur an #printLink.
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const printLink = target.closest('#printLink');
  if (!printLink) return;

  event.preventDefault();
  window.print();
});
